/** @type {import('@vue/compat').ComponentOptions} */
export default {
    data: {
        data: [],
        //分页数据
        selector: '.list',
        api: '',
        param: {
            user_id: qk_author.author_id,
            size: 10
        },
        apis: ['getFansList', 'getFollowList'],
        isDataEmpty:false,
        loading: true,
        locked:false,
    },
    mounted() {
        let index = this.$el.getAttribute('data-index');
        this.api = this.apis[index];

        Tabs();

        // 监听选项卡切换事件
        window.addEventListener('tabChange', (event) => {
            // 根据索引设置 API 地址
            this.api = this.apis[event.detail.index];
            this.data = [];
            this.loading = true;
            this.isDataEmpty = false,
            // 加载数据
            this.loadData();
        });

        // 加载数据
        this.loadData();
    },
    methods: {
        // 加载数据
        loadData() {
            this.$nextTick(() => {
                this.$refs.jsonPageNav.load(1, '', true);
            });
        },
        // 接收子组件的传值
        change(data) {
            this.data = data.data;
            this.isDataEmpty = (this.data.length === 0);
            this.loading = !this.loading;
            this.$nextTick(() => {
                listFadein(document.querySelectorAll('.follows-page .relation-list > li'),10)
            });
            
        },
        onFollow(item){
            if(!qktoken) return this.$createModal('login')
            if(this.locked == true) return
            this.locked = true
                
            this.$http.post(qk_rest_url+'userFollow','user_id=' + item.id).then(res=>{
                item.is_follow = !item.is_follow
                
                this.locked = false
                
                this.$message({ message: '操作成功' , type: 'success' });
            }).catch(err=>{
                this.locked = false
                
                this.$message({ message: qkGetApiError(err, '操作失败') , type: 'error' });
            })
        }
    }
};
